export type Falsy = false | 0 | '' | null | undefined;

export default function isTruthy<T>(x: T | Falsy): x is T {
    return Boolean(x);
}
